import React, { useEffect, useState } from "react";
import { change, Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import Modal from "../../../Components/Modal/Modal";
import UploadForm from "../../../Components/Forms/upload";

import SortableComponent from "../../../Components/Gallery/sort";
import { renderField } from "../../../Components/Forms/renders";

const SyncValidationForm = ({ handleSubmit, dispatch, initialValues }) => {
  const [visible, setVisible] = useState(false);

  const show = () => {
    setVisible(true);
  };

  const hide = () => {
    setVisible(false);
  };


  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-sm-6">
          <h4 className="info-text">Media gegevens</h4>
        </div>
      </div>
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Foto's beheren</h3>
          <div className="box-tools pull-right">
            <button type="button" className="btn btn-primary btn-sm" onClick={show}>
              <i className="fa fa-plus"></i> Upload bestanden
            </button>
          </div>
        </div>
        <div className="box-body">
          <div className="row">
            <div className="col-md-12">
              <p className="text-muted mb-3">
                Sleep de foto's om de volgorde te wijzigen. De eerste foto wordt gebruikt als hoofdafbeelding.
              </p>
              <Field name="images" component={SortableComponent} />
            </div>
          </div>
          <Modal visible={visible} onClose={hide} width={800} height={500}>
            <Field name="images"  onClose={hide} component={UploadForm} label="Kies bestanden" isModal={true} />
          </Modal>
        </div>
      </div>

      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Youtube Video</h3>
        </div>
        <div className="box-body">
          <Field name="media.video.url" label="URL van Youtube Video" component={renderField} />
        </div>
      </div>

      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Skyfocus</h3>
        </div>
        <div className="box-body">
          <Field name="media.tours.url" label="URL van skyfocus" component={renderField} />
        </div>
      </div>
      <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Opslaan" />
    </form>
  );
};

const ReduxFormSensorEdit = reduxForm({
  form: "arrangementen_edit_media", // a unique identifier for this form
})(SyncValidationForm);

const mapStateToProps = (state) => ({
  initialValues: state.arrangementen.item, // pull initial values from account reducer
});

export default connect(mapStateToProps)(ReduxFormSensorEdit);
